module.exports = __webpack_public_path__ + "static/media/avatar.751dbcbe.png";